import { gql } from '@apollo/client';

export const SENT_WIRE_TRANSFER = gql`
  mutation SentWireTransfer($input: SentWireTransferInput!) {
    sentWireTransfer(input: $input) {
      id
    }
  }
`;
